import type React from 'react'
import { useEffect, useRef, useState } from 'react'
import './otpInput.scss'
import { isValidString } from 'mmfintech-commons'

interface OptInputProps {
  codeLength?: number
  onComplete?: (value: string) => void
  disabled?: boolean
  value?: string
  // setSelectedIndex?: Dispatch<SetStateAction<number>>
  pasteGlobal?: boolean
}

export const CodeInput: React.FC<OptInputProps> = ({
  codeLength = 6,
  onComplete,
  disabled,
  value,
  pasteGlobal = true
}) => {
  const [code, setCode] = useState<string[]>(Array(codeLength).fill(''))
  const inputRefs = useRef([])

  const check = /^\d$/

  useEffect(() => {
    inputRefs.current[0]?.focus()
  }, [])

  useEffect(() => {
    if (isValidString(value)) {
      setCode(val => [...val].map((_, index) => (value[index] ? value[index] : '')))
    } else {
      setCode(Array(codeLength).fill(''))
      inputRefs.current[0]?.focus()
    }
  }, [value])

  // const focusPrevChar = (target: any) => {
  //   if (target.previousElementSibling !== null) {
  //     target.previousElementSibling.focus()
  //     // In most browsers .select() does not work without the added timeout.
  //     setTimeout(() => target.previousElementSibling.select(), 0)
  //   }
  // }

  // const focusNextChar = (target: any) => {
  //   if (target.nextElementSibling !== null) {
  //     target.nextElementSibling.focus()
  //     // In most browsers .select() does not work without the added timeout.
  //     setTimeout(() => target.nextElementSibling.select(), 0)
  //   }
  // }

  const isValidCode = (value: string[]) => value.every(digit => check.test(digit))

  const handleChange = (e, index: number) => {
    const value = e.value

    const newCode = [...code]
    newCode[index] = check.test(value) ? value : ''
    setCode(newCode)

    if (value && index < codeLength - 1) {
      inputRefs.current[index + 1]?.focus()
    }

    if (isValidCode(newCode)) {
      onComplete(newCode.join(''))
    }
  }

  const handleKeyDown = (e, index: number) => {
    switch (e.key) {
      case 'Backspace':
        if (code[index] === '' && index > 0) {
          inputRefs.current[index - 1]?.focus()
        }
        break

      // case 'ArrowLeft':
      //   if (index > 0) {
      //     inputRefs.current[index - 1]?.focus()
      //   }
      //   break
      // case 'ArrowRight':
      //   if (index < codeLength - 1) {
      //     inputRefs.current[index + 1]?.focus()
      //   }
      //   break
    }
  }

  const handleOnPaste = (e, index) => {
    e.preventDefault()

    const pasteData = e.clipboardData.getData('Text').trim()
    const digits = pasteData.split('').filter(char => check.test(char))

    const newCode = [...code]
    let i = pasteGlobal ? 0 : index

    for (const digit of digits) {
      if (i < codeLength) {
        newCode[i] = digit
        i++
      }
    }

    setCode(newCode)

    if (i < codeLength) {
      inputRefs.current[i]?.focus()
    }

    if (newCode.every(digit => check.test(digit))) {
      onComplete(newCode.join(''))
    }
  }

  // 1234567

  return (
    <div className='otp-input-wrapper'>
      {code.map((digit, index) => (
        <input
          key={index}
          type='text'
          maxLength={1}
          disabled={disabled}
          value={digit}
          data-test={index === 0 ? 'otp-first-input' : `otp-input-${index}`}
          className='opt-input'
          name={`input${index}`}
          ref={el => {
            inputRefs.current[index] = el
          }}
          onChange={e => handleChange(e.target, index)}
          onKeyDown={e => handleKeyDown(e, index)}
          onPaste={e => handleOnPaste(e, index)}
        />
      ))}
    </div>
  )
}
